var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftTop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1007,
    height: 1134,
    viewBox: "0 0 1007 1134",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_101_1129)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 591.931,
    cy: 419.253,
    rx: 264.014,
    ry: 269.036,
    transform: "rotate(11.4826 591.931 419.253)",
    fill: "#1AD7B5",
    fillOpacity: 0.65
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_101_1129)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 502.188,
    cy: 644.807,
    rx: 252.536,
    ry: 238.187,
    transform: "rotate(11.4826 502.188 644.807)",
    fill: "#0052F5",
    fillOpacity: 0.75
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_101_1129",
    x: 177.663,
    y: 0.362305,
    width: 828.536,
    height: 837.781,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_101_1129"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_101_1129",
    x: 0.159668,
    y: 155.985,
    width: 1004.06,
    height: 977.644,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_101_1129"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTop);
export default __webpack_public_path__ + "static/media/left-top.775e2b7effa29b277fe64adadbf5e967.svg";
export { ForwardRef as ReactComponent };